import React from 'react'
import {useTranslation} from 'react-i18next'

import {Box, Grid} from '@mui/material'
import {
  PGButton,
  getSpacing,
  PGTheme,
  getProductLineColors,
} from '@progynyglobal/pg-ui-library'
import clsx from 'clsx'
import {makeStyles} from 'tss-react/mui'

import {useProductLine} from '@progyny/hooks/useProductLine'
import {SetupProfileSubProps} from '@progyny/pages/SetUpProfile/types'

import {PregnancyInfoOptions, UNSET} from '../../../const'

const useStyles = makeStyles<{
  colors?: any
}>()((theme, {colors}) => ({
  button: {
    padding: getSpacing(16),
    fontSize: 18,
    borderRadius: getSpacing(16),
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  secondaryBtn: {
    border: `1px solid ${colors.primary}`,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: colors.secondary,
    },
  },
  outlinedBtn: {
    border: `1px solid ${PGTheme.common.lightGray}`,
    color: PGTheme.common.black,
    fontWeight: 400,
    '&:hover': {
      color: PGTheme.common.black,
      border: `1px solid ${PGTheme.common.lightGray}`,
    },
  },
}))

const PregnancyInfo: React.FC<SetupProfileSubProps> = (props) => {
  const {
    navigator: Navigator,
    callback,
    onboardingData,
    persistMemberData,
  } = props

  const {t} = useTranslation()
  const {productLine} = useProductLine()
  const colors = getProductLineColors(productLine)
  const {classes} = useStyles({colors})
  const choices = PregnancyInfoOptions.filter((item) => {
    if (item.value === UNSET) return false
    return true
  })

  const handleChoiceClick = (choice: string) => {
    persistMemberData({pregnancyPostpartumStatus: choice}, callback)
  }

  return (
    <>
      <Grid container justifyContent={'center'}>
        <Grid item xs={12}>
          <Box
            mt={3}
            width='100%'
            display={'flex'}
            flexDirection={'column'}
            gap={3}
          >
            {choices.map((item, index) => (
              <PGButton
                data-role={item.value}
                className={clsx(classes.button, {
                  [classes.secondaryBtn]:
                    onboardingData.pregnancyPostpartumStatus === item.value,
                  [classes.outlinedBtn]:
                    onboardingData.pregnancyPostpartumStatus !== item.value,
                })}
                variant={
                  onboardingData.pregnancyPostpartumStatus === item.value
                    ? 'secondary'
                    : 'outlined'
                }
                key={item.value}
                onClick={() => handleChoiceClick(item.value)}
                label={t(item.label!)}
              />
            ))}
          </Box>
        </Grid>
      </Grid>
      <Box mt={6}>
        <Navigator submitDataRole={'pregnancy-info'} showBackButton={false} />
      </Box>
    </>
  )
}

export default PregnancyInfo
